import CustomerService from "@services/customer-service";
import { MarketingData } from "./step-1/setp1.component";

export const checkIfStringHasLowerCase = (string: string): boolean => {
  return /[a-z]/.test(string);
};

export const checkIfStringHasUpperCase = (string: string): boolean => {
  return /[A-Z]/.test(string);
};

export const checkIfStringHasAtLeastOneNumber = (string: string): boolean => {
  return /\d/.test(string);
};

export const checkIfStringHasSpecialCharacter = (string: string): boolean => {
  return /[^A-Za-z0-9]/.test(string);
};

export const checkIfStringHas15Characters = (string: string): boolean => {
  return /.{15,}/.test(string);
};

export const handleNext = (setFormStep: any): void => {
  setFormStep(2);
};

// export const onSubmit = async (values: any, setOpenOtp: any, setSubmitBtnStatus: any, setEmail: any, search: any, handleReCaptchaVerify: any) => {
//   setOpenOtp(true);
//   setSubmitBtnStatus(false);
//   setEmail(values.email);
//   const url = new URLSearchParams(search);

//   try {
//     await $axios.post("register/confirm", {
//       ref: url.get("ref"),
//       ...values,
//       utm_campaign: url.get("utm_campaign"),
//       utm_medium: localStorage.getItem("utm_medium"),
//       utm_source: localStorage.getItem("utm_source"),
//       utm_term: localStorage.getItem("utm_term"),
//       utm_content: localStorage.getItem("utm_content"),
//       utm_adgroup: localStorage.getItem("utm_adgroup"),
//       reToken: await handleReCaptchaVerify(),
//     });
//   } catch (err: any) {
//     console.error(err);
//     toast.error(err.message || err.data.message || "Error occured");
//   }
// };

export const validateEmail = async function (
  email: any,
  handleReCaptchaVerify: any
) {
  if (!email) return false;
  try {
    const {
      data: [data0],
    } = await CustomerService.isDisposable({
      email,
      reToken: await handleReCaptchaVerify(),
    });
    return data0.exists;
  } catch (e) {
    console.error(e);
    return false;
  }
};
export const validateUsername = async function (
  username: any,
  handleReCaptchaVerify: any
) {
  if (!username) return false;
  if (!/^[a-zA-Z0-9_]+$/.test(username)) return false;
  try {
    const {
      data: [data0],
    } = await CustomerService.isExists({
      username,
      reToken: await handleReCaptchaVerify(),
    });
    return !data0.exists;
  } catch (e) {
    console.error(e);
    return true;
  }
};

export const isUserNameExists = async (
  username: string,
  handleReCaptchaVerify: any
) => {
  try {
    const {
      data: [data0],
    } = await CustomerService.isExists({
      username,
      reToken: await handleReCaptchaVerify(),
    });
    console.log("data0.exists: ", data0.exists);
    return data0.exists;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const validateIsEmailExists = async function (
  email: string,
  handleReCaptchaVerify: any
) {
  if (!email) return false;
  try {
    const {
      data: [data0],
    } = await CustomerService.isExists({
      email,
      reToken: await handleReCaptchaVerify(),
    });
    return data0.exists;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const setAffiliateData = (search: any): MarketingData => {
  const url = new URLSearchParams(search);
  const ref = url.get("ref");
  if (ref != null && ref != undefined) {
    localStorage.setItem("ref", ref);
  }
  const utmSource = url.get("utm_source");
  if (utmSource != null && utmSource != undefined) {
    localStorage.setItem("utm_source", utmSource);
  }
  const utmMedium = url.get("utm_medium");
  if (utmMedium != null && utmMedium != undefined) {
    localStorage.setItem("utm_medium", utmMedium);
  }
  const utmterm = url.get("utm_term");
  if (utmterm != null && utmterm != undefined) {
    localStorage.setItem("utm_term", utmterm);
  }
  const utmContent = url.get("utm_content");
  if (utmContent != null && utmContent != undefined) {
    localStorage.setItem("utm_content", utmContent);
  }
  const utmAdgroup = url.get("utm_adgroup");
  if (utmAdgroup != null && utmAdgroup != undefined) {
    localStorage.setItem("utm_adgroup", utmAdgroup);
  }

  const utmCampaign = url.get("utm_campaign");
  if (utmCampaign != null && utmCampaign != undefined) {
    localStorage.setItem("utm_campaign", utmCampaign);
  }
  return {
    ref: ref || "",
    utm_adgroup: utmAdgroup || "",
    utm_campaign: utmCampaign || "",
    utm_content: utmContent || "",
    utm_medium: utmMedium || "",
    utm_source: utmSource || "",
    utm_term: utmterm || "",
  };
};
